var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8595 0.529892C18.5494 1.38056 11.7613 5.00709 7.09179 10.5887C-0.173626 19.2595 -1.68042 31.2136 3.18308 41.3769C6.0624 47.3614 10.6574 51.958 16.6248 54.8234C26.7994 59.7036 38.7493 58.1962 47.4171 50.9282C53.847 45.5556 57.6364 37.4071 57.6364 29.0198C57.6364 20.6325 53.847 12.484 47.4171 7.11138C41.4496 2.09691 33.4382 -0.335701 25.8595 0.529892ZM29.0074 25.453C30.8871 27.3185 32.4238 28.9303 32.4238 29.0347C32.4238 29.2138 28.2316 33.3925 18.9372 42.5111L16.4011 44.9885L14.9092 43.511C14.0737 42.7051 12.925 41.5709 12.3283 40.9739L11.269 39.8845L14.6108 36.5863C16.4607 34.7655 18.9074 32.3479 20.0561 31.2136C21.19 30.0943 22.1298 29.0944 22.1298 29.0198C22.1298 28.9452 20.9214 27.6916 19.4445 26.229C12.7161 19.6028 11.2392 18.1253 11.3585 18.1253C11.4182 18.1253 12.5968 16.9911 13.9693 15.6181L16.4757 13.1108L21.0408 17.6029C23.5322 20.0654 27.1276 23.6024 29.0074 25.453ZM49.8786 29.0198V32.6016H43.2398H36.601V29.0198V25.438H43.2398H49.8786V29.0198Z",
    fill: "#0F0F19"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBck);
export default __webpack_public_path__ + "static/media/bck.5467b352e9d54763afbf7bd5112260fb.svg";
export { ForwardRef as ReactComponent };